import React, { useEffect, useState } from 'react';
// Material-UI removido em favor do Tailwind Glassmorphism
import axios from 'axios';
import jsPDF from 'jspdf';
import GlobalLoading from '../components/GlobalLoading';
const MiniCalendar = ({ selectedDate, onChange }) => {
    const today = new Date();
    // Parse selectedDate ignoring timezone shift if formatted as YYYY-MM-DD
    const initialView = selectedDate ? new Date(selectedDate + "T12:00:00") : today;
    
    const [viewDate, setViewDate] = useState(initialView);

    const prevMonth = () => {
        setViewDate(new Date(viewDate.getFullYear(), viewDate.getMonth() - 1, 1));
    };

    const nextMonth = () => {
        setViewDate(new Date(viewDate.getFullYear(), viewDate.getMonth() + 1, 1));
    };

    const daysInMonth = new Date(viewDate.getFullYear(), viewDate.getMonth() + 1, 0).getDate();
    const firstDayIndex = new Date(viewDate.getFullYear(), viewDate.getMonth(), 1).getDay();

    const monthNames = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
    const daysOfWeek = ["D", "S", "T", "Q", "Q", "S", "S"];

    const handleDayClick = (day) => {
        const year = viewDate.getFullYear();
        const month = String(viewDate.getMonth() + 1).padStart(2, '0');
        const dayStr = String(day).padStart(2, '0');
        onChange(`${year}-${month}-${dayStr}`);
    };

    return (
        <div className="bg-black/20 border border-white/5 rounded-xl p-4 w-full mt-2">
            {/* Header */}
            <div className="flex justify-between items-center mb-4">
                <button type="button" onClick={prevMonth} className="text-gray-400 hover:text-white p-1 rounded hover:bg-white/10 transition-colors">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
                </button>
                <div className="text-sm font-semibold text-gray-200">
                    {monthNames[viewDate.getMonth()]} {viewDate.getFullYear()}
                </div>
                <button type="button" onClick={nextMonth} className="text-gray-400 hover:text-white p-1 rounded hover:bg-white/10 transition-colors">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
                </button>
            </div>
            
            {/* Days of Week */}
            <div className="grid grid-cols-7 gap-1 text-center mb-2">
                {daysOfWeek.map((d, i) => (
                    <div key={i} className="text-[10px] font-semibold text-gray-500">{d}</div>
                ))}
            </div>
            
            {/* Calendar Grid */}
            <div className="grid grid-cols-7 gap-1 text-center">
                {Array.from({ length: firstDayIndex }).map((_, i) => (
                    <div key={`empty-${i}`} className="h-7 w-7"></div>
                ))}
                {Array.from({ length: daysInMonth }).map((_, i) => {
                    const day = i + 1;
                    const dateStr = `${viewDate.getFullYear()}-${String(viewDate.getMonth() + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
                    const isSelected = selectedDate === dateStr;
                    return (
                        <button
                            type="button"
                            key={day}
                            onClick={() => handleDayClick(day)}
                            className={`h-7 w-7 mx-auto flex justify-center items-center rounded-full text-xs font-medium transition-all ${
                                isSelected 
                                    ? 'bg-green-500 text-white shadow-[0_0_10px_rgba(34,197,94,0.5)] border border-green-400' 
                                    : 'text-gray-300 hover:bg-white/10 hover:text-white border border-transparent'
                            }`}
                        >
                            {day}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

const TelaContratoTermo = () => {
    const [clientes, setClientes] = useState([]);
    const [produtos, setProdutos] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [clienteSelecionadoContrato, setClienteSelecionadoContrato] = useState(null);  // Para a geração de contrato
    const [clienteSelecionadoTermo, setClienteSelecionadoTermo] = useState(null);  // Para a geração de termo
    const [filtroClienteContrato, setFiltroClienteContrato] = useState(''); // Filtro específico para o contrato
    const [filtroClienteTermo, setFiltroClienteTermo] = useState(''); // Filtro específico para o termo
    const [loading, setLoading] = useState(true); // Controla o estado de carregamento
    const [produtosSelecionados, setProdutosSelecionados] = useState([]); // Armazena os produtos selecionados
    const [quantidades, setQuantidades] = useState({}); // Armazena a quantidade de cada produto selecionado
    const [modeloContrato, setModeloContrato] = useState(''); // Modelo de contrato
    const [modeloTermo, setModeloTermo] = useState(''); // Modelo de termo de entrega
    const [dataEntrega, setDataEntrega] = useState(''); // Estado para a data de entrega
    const [currentPage, setCurrentPage] = useState(1);
    const [productsPerPage] = useState(8);
    const [filtroCategoria, setFiltroCategoria] = useState('');
    const [filtroProduto, setFiltroProduto] = useState(''); // Estado para filtrar produtos por nome

    const [erroQuantidade, setErroQuantidade] = useState(false);
    const [erroClienteSelecionado, setErroClienteSelecionado] = useState(false);
    const [erroDataEntrega, setErroDataEntrega] = useState(false);
    const [erroProduto, setErroProduto] = useState(false);

    useEffect(() => {
        fetchClientesProdutos();
        fetchModeloContrato();
        fetchModeloTermo();
    }, []);

    const handleCloseError = () => {
        setErroQuantidade(false);
        setErroClienteSelecionado(false);
        setErroDataEntrega(false);
        setErroProduto(false);
    };

    // Função para buscar os clientes e produtos
    const fetchClientesProdutos = async () => {
        try {
            const responseClientes = await axios.get(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/clientRoutes/clientes`);
            const responseProdutos = await axios.get(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/productRoutes/product`);
            setClientes(responseClientes.data);
            setProdutos(responseProdutos.data);

            // Extrair categorias únicas dos produtos
            const categoriasExtraidas = [...new Set(responseProdutos.data.map(produto => produto.categoria))];
            setCategorias(categoriasExtraidas);

            setLoading(false);
        } catch (error) {
            console.error('Erro ao buscar clientes ou produtos:', error);
            setLoading(false);
        }
    };

    // Função para buscar o modelo de contrato
    const fetchModeloContrato = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/legalRoutes/legal-documents`);
            setModeloContrato(response.data[0]?.texto_documento || ''); // Pega o contrato na posição [0]
        } catch (error) {
            console.error('Erro ao buscar modelo de contrato:', error);
        }
    };

    // Função para buscar o modelo de termo de entrega
    const fetchModeloTermo = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/legalRoutes/legal-documents`);
            setModeloTermo(response.data[1]?.texto_documento || ''); // Pega o termo de entrega na posição [1]
        } catch (error) {
            console.error('Erro ao buscar modelo de termo:', error);
        }
    };

    // Função para selecionar cliente para o contrato
    const handleClienteChangeContrato = (event) => {
        const client = clientes.find(c => c.id === Number(event.target.value));
        setClienteSelecionadoContrato(client || null);
    };

    // Função para selecionar cliente para o termo
    const handleClienteChangeTermo = (event) => {
        const client = clientes.find(c => c.id === Number(event.target.value));
        setClienteSelecionadoTermo(client || null);
    };

    const handleQuantidadeChange = (produtoId, e) => {
        const novaQuantidade = e.target.value;
        if (novaQuantidade === "" || Number(novaQuantidade) >= 0) {
            setQuantidades(prevQuantidades => ({
                ...prevQuantidades,
                [produtoId]: novaQuantidade
            }));
        }
    };

    const handleQuantidadeIncrement = (produtoId) => {
        setQuantidades(prev => {
            const current = prev[produtoId] ? parseInt(prev[produtoId], 10) : 0;
            return { ...prev, [produtoId]: current + 1 };
        });
    };

    const handleQuantidadeDecrement = (produtoId) => {
        setQuantidades(prev => {
            const current = prev[produtoId] ? parseInt(prev[produtoId], 10) : 0;
            if (current > 0) {
                return { ...prev, [produtoId]: current - 1 };
            }
            return prev;
        });
    };

    const processarTextoContrato = (texto) => {
        const partes = texto.split(/\{(.*?)\}/); // Divide o texto com base em chaves

        const processedParts = partes.map((parte, index) => {
            if (index % 2 === 1) {
                // Se for uma parte que estava entre chaves, formata como título (negrito)
                return { tipo: 'titulo', texto: parte };
            } else {
                // Se não estiver entre chaves, é texto normal
                return { tipo: 'texto', texto: parte };
            }
        });

        return processedParts;
    };

    // Função para gerar o PDF do contrato
    const handleGerarContratoPDF = () => {
        if (!clienteSelecionadoContrato) {
            setErroClienteSelecionado(true)
            return;
        }

        // Verifica se todos os produtos selecionados têm uma quantidade maior que 0
        const produtosComQuantidadeValida = produtosSelecionados.every((produto) => {
            const quantidade = quantidades[produto.id] || 0; // Pega a quantidade ou 0 por padrão
            return quantidade > 0;
        });

        if (!produtosComQuantidadeValida) {
            setErroQuantidade(true)
            return;
        }

        if (produtosSelecionados.length === 0) {
            setErroProduto(true)
            return;
        }

        const hoje = new Date();

        const meses = [
            'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
            'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
        ];

        const dia = hoje.getDate();
        const mesNome = meses[hoje.getMonth()]; // pega o nome do mês
        const ano = hoje.getFullYear();

        // Criação da lista de produtos e quantidades
        var valorTotalProjeto = 0;
        const listaProdutos = produtosSelecionados
            .map((produto) => {
                const quantidade = quantidades[produto.id] || 1; // Pega a quantidade definida ou 1 por padrão
                const totalProduto = produto.valor * quantidade; // Calcula o total de cada produto
                valorTotalProjeto = valorTotalProjeto + totalProduto; // Adiciona ao total do projeto
                return `${produto.nome}: ${formatarParaBRL(produto.valor)} (Quantidade: ${quantidade}) - Total: ${formatarParaBRL(totalProduto)}`;
            })
            .join('\n    ');  // Agora cada produto estará em uma nova linha

        const contratoTexto = `
            {CONTRATO DE COMPRA E VENDA DE PRODUTO(S)}
            
Pelo presente instrumento particular, as partes:
**VENDEDOR:**
Razão Social: CS CHURRASQUEIRAS GIRATÓRIAS LTDA
CNPJ: 30.402.034/0001-73
Endereço da Sede: Rua Teresina, nº 175, Bairro Tapajós, Município de Indaial/SC,
CEP: 89080-269
Telefone: (47)9 8849-2122

**COMPRADOR(A):**
Nome completo: ${clienteSelecionadoContrato.nome}
Inscrito(a) no CPF sob o nº: ${clienteSelecionadoContrato.cpf_cnpj}
Endereço: ${clienteSelecionadoContrato.rua}, ${clienteSelecionadoContrato.bairro}, ${clienteSelecionadoContrato.cidade}, ${clienteSelecionadoContrato.cep}
Telefone: ${clienteSelecionadoContrato.telefone}

As partes acima identificadas têm, entre si, justo e contratado o presente Contrato de Compra e Venda de Produto(s), que se regerá pelas cláusulas e condições seguintes, previamente esti-
puladas e em consonância com o Código de Defesa do Consumidor (Lei nº 8.078/1990).


{CLÁUSULA PRIMEIRA - DO OBJETO}

1.1. Por meio deste instrumento particular o VENDEDOR declara a venda ao COMPRADOR
(A) das mercadorias a seguir discriminadas com seus respectivos valores:

    ${listaProdutos}

1.2. O(s) produto(s) é(são) vendido(s) no estado em que se encontra(m), conforme especifica-
do na descrição acima, sendo de pleno conhecimento do COMPRADOR(A) suas característi-
cas, valores e funcionalidades, eis que previamente acordados.

1.3 A forma de pagamento será previamente estipulada entre as partes e, de comum acordo, as partes estabelecem que a inadimplência de qualquer parcela na data aprazada sujeitará o COM
PRADOR(A) ao pagamento de multa moratória de 2% (dois por cento) sobre o valor da par-
cela em atraso. Adicionalmente, incidirão sobre o valor devido, devidamente atualizado mo-
netariamente pelo índice oficial de correção monetária, juros de mora de 1% (um por cento) ao mês, desde a data do vencimento até a data do efetivo pagamento. Essas penalidades serão aplicadas sem prejuízo de outras medidas legais cabíveis que o VENDEDOR(A) possa tomar
para a cobrança do débito e/ou recuperação do(s) produto(s), incluindo a possibilidade de considerar o contrato rescindido.


{CLÁUSULA SEGUNDA – DA ENTREGA DOS PRODUTOS}

2.1. O(s) produto(s) será(ão) entregue(s) e montados pelo VENDEDOR no endereço previa-
mente informado pelo COMPRADOR(A) na data da compra.

2.2. No ato da entrega, o COMPRADOR(A) deverá verificar a integridade e a conformidade do(s) produto(s) com o pedido. Havendo qualquer divergência, avaria aparente ou vício de fá-
cil constatação, esta deverá ser comunicada imediatamente ao VENDEDOR.


{CLÁUSULA TERCEIRA – DA MONTAGEM DOS PRODUTOS}

3.1. A montagem do(s) produto(s) listado(s) na Cláusula Primeira, quando aplicável e nece-
ssário conforme a natureza do(s) mesmo(s), será de integral responsabilidade do VENDEDOR
não acarretando quaisquer ônus ou custos adicionais para o COMPRADOR(A).

3.2. A montagem será realizada pela equipe técnica designada e custeada pelo VENDEDOR, em data e horário a serem previamente agendados com o COMPRADOR(A).

3.3. O COMPRADOR(A) se compromete a disponibilizar o local onde o(s) produto(s) será(ão) montado(s) em condições adequadas, livre de obstáculos e com espaço suficiente para a execução do serviço na data e horário agendados.

3.4. Caso a montagem não possa ser realizada na data agendada por responsabilidade do COMPRADOR(A), uma nova data será agendada, podendo o VENDEDOR(A), mediante prévia comunicação e concordância do COMPRADOR(A), cobrar uma taxa referente aos custos de um novo deslocamento, se aplicável.


{CLÁUSULA QUARTA – DA GARANTIA}

4.1. O(s) produto(s) objeto deste contrato goza(m) da garantia legal estabelecida pelo Código de Defesa do Consumidor, que é de 90 (noventa) dias para vícios (defeitos) aparentes ou de fácil constatação em produtos duráveis, a contar da data da entrega efetiva do produto.

4.2. Adicionalmente à garantia legal, o VENDEDOR(A) concede garantia contratual comple-
mentar, nos seguintes termos, contados a partir da data da entrega efetiva do produto:

        a) Garantia de 06 (seis) meses para a parte elétrica dos produtos, cobrindo vícios ou
        defeitos de funcionamento nos componentes elétricos.

        b) Garantia de 03 (três) anos para defeitos de fabricação nos demais componentes
        do produto (não elétricos) ou defeitos estruturais de fabricação que não se enquadrem 
        como problemas elétricos.

        c) Garantia de 10 (dez) anos para as peças de inox contra oxidação natural, não 
        provocadas por produtos abrasivos e/ou culpa exclusiva do COMPRADOR(A).

4.3. A garantia prevista nesta cláusula NÃO COBRE:

        a) Danos causados por mau uso, negligência, imperícia, imprudência, ou uso em 
        desacordo com as instruções do fabricante/manual;

        b) Desgaste natural de peças devido ao uso regular - exceto hipótese prevista na alínea 
        “c” do item 4.2;

        c) Danos decorrentes de instalação, montagem ou manutenção inadequada ou realizada 
        por terceiros não autorizados pelo VENDEDOR(A);

        d) Modificações, violações ou reparos realizados no produto por pessoas não autorizadas 
        pelo VENDEDOR;

        e) Danos causados por acidentes, quedas, sinistros, catástrofes naturais (raios, inunda-
        ções, etc.), ou agentes externos (pragas, umidade excessiva, maresia, etc.);

        f) Problemas decorrentes de flutuações excessivas de energia elétrica ou uso em volta-
        gem inadequada (para produtos elétricos);

        g) Peças ou componentes que possuam vida útil limitada ou que sejam considerados 
        consumíveis, exceto se o defeito for de fabricação.

4.4. Para acionar a garantia, o COMPRADOR(A) deverá contatar o VENDEDOR através
dos canais informados no preâmbulo deste contrato, apresentando este contrato e/ou a nota fiscal de compra, e uma descrição clara do defeito apresentado.

4.5. Constatado o defeito coberto pela garantia, o VENDEDOR(A) se compromete a, no prazo legal de até 30 (trinta) dias (Art. 18, §1º do CDC), sanar o vício, podendo, à sua escolha ou conforme disponibilidade: reparar o produto, substituí-lo por outro igual ou similar em perfei-
tas condições de uso, ou, em último caso, se não for possível o reparo ou substituição, seguir as alternativas previstas no CDC.


{CLÁUSULA QUINTA – DA RESCISÃO}

5.1. O presente contrato poderá ser rescindido por qualquer das partes em caso de descumprimento de quaisquer de suas cláusulas e condições, sujeitando-se a parte infratora às penalidades previstas em lei e neste contrato, sem prejuízo de indenização por perdas e danos.

5.2. A rescisão por iniciativa do COMPRADOR(A), fora das hipóteses de vício do produto ou direito de arrependimento (quando aplicável), após a entrega e aceitação do produto poderá sujeitá-lo a penalidades contratuais a serem acordadas ou, na ausência de acordo, definidas judicialmente, respeitados os limites do CDC.


{CLÁUSULA SEXTA– DAS DISPOSIÇÕES GERAIS}

6.1. Qualquer alteração às condições estabelecidas neste contrato só terá validade se feita por escrito, através de Termo Aditivo, devidamente assinado por ambas as partes.

6.2. A eventual tolerância de uma das partes quanto ao descumprimento de qualquer obriga-
ção pela outra parte não implicará em novação, renúncia de direitos ou alteração das cláusulas contratuais.


{CLÁUSULA SÉTIMA – DO FORO}

7.1. Para dirimir quaisquer controvérsias oriundas do presente contrato, as partes elegem o fo-
ro da comarca de Indaial, com renúncia expressa a qualquer outro, por mais privilegiado que seja. E, por estarem assim justos e contratados, as partes assinam o presente instrumento em 02 (duas) vias de igual teor e forma, na presença das duas testemunhas abaixo.

Indaial, ${dia} de ${mesNome} de ${ano}

 _______________________________             _______________________________
CS CHURRASQUEIRAS GIRATÓRIAS                        COMPRADOR(A)
`;


        // Processa o texto do contrato
        const contratoProcessado = processarTextoContrato(contratoTexto);

        // Criação do PDF com jsPDF
        const doc = new jsPDF();

        // Definir margens de 25px para a esquerda e direita
        const margin = 25;
        const pageWidth = doc.internal.pageSize.width;

        // Inicializa a posição Y no PDF
        let yPos = 20;
        const lineHeight = 8; // Altura de cada linha
        const titleSpacing = 1.5; // Espaçamento entre título e parágrafo (ajustável)
        const paragraphSpacing = 1; // Espaçamento entre parágrafos

        contratoProcessado.forEach((parte) => {
            if (parte.tipo === 'titulo') {
                doc.setFont('arial', 'bold');
                doc.setFontSize(14);
                if (parte.texto === 'CONTRATO DE COMPRA E VENDA DE PRODUTO(S)') {
                    const titleWidth = doc.getTextWidth(parte.texto);
                    const xPos = (pageWidth - titleWidth) / 2;
                    doc.text(parte.texto, xPos, yPos);
                } else {
                    doc.text(parte.texto, margin, yPos);
                }
                yPos += paragraphSpacing - 5;
            } else {
                doc.setFont('arial', 'normal');
                doc.setFontSize(12);
                const textLines = doc.splitTextToSize(parte.texto, pageWidth - 2 * margin);

                textLines.forEach((line) => {
                    // Checagem de página
                    if (yPos + lineHeight > doc.internal.pageSize.height - margin) {
                        doc.addPage();
                        yPos = margin;
                    }

                    const words = line.split(/(\s+)/); // Mantém espaços

                    let xCursor = margin;

                    words.forEach((word) => {
                        if (word.startsWith('**') && word.endsWith('**')) {
                            const cleanWord = word.replace(/\*\*/g, '');
                            doc.setFont('arial', 'bold');
                            doc.text(cleanWord, xCursor, yPos);
                            xCursor += doc.getTextWidth(cleanWord + ' ');
                            doc.setFont('arial', 'normal');
                        } else {
                            doc.text(word, xCursor, yPos);
                            xCursor += doc.getTextWidth(word);
                        }
                    });

                    yPos += lineHeight;
                });


                yPos += paragraphSpacing - 15;
            }
        });


        // Salva o PDF
        doc.save('Contrato.pdf');
    };


    // Função para gerar o PDF do Termo de Entrega
    const handleGerarTermoPDF = () => {
        if (!clienteSelecionadoTermo) {
            setErroClienteSelecionado(true)
            return;
        }

        if (!dataEntrega) {
            setErroDataEntrega(true)
            return;
        }

        // Cria uma nova data a partir da string de dataEntrega e define a hora como 00:00:00
        const dataObj = new Date(dataEntrega + "T00:00:00");

        // Formatar a data para dd-MM-yyyy
        const dia = String(dataObj.getDate()).padStart(2, '0'); // Garantir que o dia tenha 2 dígitos
        const mes = String(dataObj.getMonth() + 1).padStart(2, '0'); // Mês é 0-indexado, então adicionamos 1
        const ano = dataObj.getFullYear();

        // Converte para o formato pt-BR
        const dataFormatada = `${dia}-${mes}-${ano}`;

        // Preenche o modelo do termo com as informações dinâmicas
        const termoTexto = ` 
    {TERMO DE ENTREGA}

    Pelo presente instrumento, a empresa CS Churrasqueiras, inscrita no CNPJ nº 30.402.034/0001-73, declara que, conforme o contrato firmado, a entrega das mercadorias será realizada ao cliente: [CLIENT_NAME] - [CLIENT_CPF_CNPJ]. Data de entrega acordada: [DELIVERY_DATE].
    O CS Churrasqueiras se compromete a entregar os produtos conforme as condições estabelecidas no contrato.
    
    {CLÁUSULA PRIMEIRA - DA ENTREGA}

    A entrega será realizada na data acordada e no local determinado entre as partes. Caso haja qualquer alteração, o [CLIENT_NAME] será informado previamente.

    {CLÁUSULA SEGUNDA - DAS RESPONSABILIDADES}

    O CS Churrasqueiras assume a responsabilidade pela entrega das mercadorias em perfeitas condições. O [CLIENT_NAME], por sua vez, assume a responsabilidade por verificar os produtos no momento da entrega e indicar qualquer irregularidade.

    {CLÁUSULA TERCEIRA - DO PAGAMENTO}

    O pagamento será realizado conforme o estipulado no contrato, na data da entrega ou conforme o acordo entre as partes.
    
    {TERMO DE ENCERRAMENTO}

    Declaro, para os devidos fins, que a entrega será realizada conforme o acordado, e que as responsabilidades de ambas as partes foram explicadas e compreendidas.

    Assinatura CS Churrasqueiras: ____________________________
    Assinatura recebedor: __________________________
    `;

        // Substitui todos os placeholders no termo com as informações dinâmicas
        const termoPreenchido = termoTexto
            .replace(/\[CLIENT_NAME\]/g, clienteSelecionadoTermo.nome) // Usando regex para substituir todas as ocorrências
            .replace(/\[CLIENT_CPF_CNPJ\]/g, clienteSelecionadoTermo.cpf_cnpj) // Usando regex para substituir todas as ocorrências
            .replace(/\[DELIVERY_DATE\]/g, dataFormatada); // Usando regex para substituir todas as ocorrências

        // Criação do PDF com jsPDF
        const doc = new jsPDF();

        // Definir margens de 25px para a esquerda e direita
        const margin = 25;
        const pageWidth = doc.internal.pageSize.width;

        // Inicializa a posição Y no PDF
        let yPos = 15;
        const lineHeight = 10; // Altura de cada linha
        const titleSpacing = 1.5; // Espaçamento entre título e parágrafo (ajustável)
        const paragraphSpacing = 1; // Espaçamento entre parágrafos

        // Quebra o texto do termo em partes para garantir a formatação correta
        const termoProcessado = processarTextoContrato(termoPreenchido);

        termoProcessado.forEach((parte) => {
            if (parte.tipo === 'titulo') {
                // Se for título, coloca em negrito
                doc.setFont('arial', 'bold');
                doc.setFontSize(12);
                if (parte.texto === 'TERMO DE ENTREGA') {
                    // Calcula a posição X para centralizar o título
                    const titleWidth = doc.getTextWidth(parte.texto);
                    const xPos = (pageWidth - titleWidth) / 2;
                    doc.text(parte.texto, xPos, yPos); // Centraliza o título
                } else {
                    doc.text(parte.texto, margin, yPos); // Outros títulos alinhados à esquerda
                }
                yPos += paragraphSpacing - 5; // Ajusta a posição Y para o texto seguinte com espaçamento
            } else {
                // Se for texto normal, coloca em fonte normal
                doc.setFont('arial', 'normal');
                doc.setFontSize(12);
                // Quebra o texto em linhas para evitar que ele saia da página
                const textLines = doc.splitTextToSize(parte.texto, pageWidth - 2 * margin);

                // Adiciona cada linha do texto (quebrado automaticamente) no PDF
                textLines.forEach((line) => {
                    doc.text(line, margin, yPos);
                    yPos += lineHeight; // Atualiza a posição Y para a próxima linha
                });

                // Adiciona um espaçamento entre parágrafos
                yPos += paragraphSpacing - 15; // Ajuste do espaçamento entre parágrafos
            }
        });

        // Salva o PDF
        doc.save('Termo_de_Entrega.pdf');
    };

    // Função para selecionar/desmarcar produtos
    const handleSelectProduct = (produto) => {
        if (produtosSelecionados.some((p) => p.id === produto.id)) {
            setProdutosSelecionados(produtosSelecionados.filter((p) => p.id !== produto.id));
        } else {
            setProdutosSelecionados([...produtosSelecionados, produto]);
        }
    };

    const formatarParaBRL = (valor) => {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        }).format(valor);
    };

    // Filtra os produtos pela categoria e pelo nome do produto
    const produtosFiltrados = produtos.filter(produto => {
        const matchesCategoria = filtroCategoria ? produto.categoria === filtroCategoria : true;
        const matchesProduto = filtroProduto ? produto.nome.toLowerCase().includes(filtroProduto.toLowerCase()) : true;
        return matchesCategoria && matchesProduto;
    });

    // Calcular o total de páginas após o filtro
    const totalPages = Math.ceil(produtosFiltrados.length / productsPerPage);

    // Obtem os produtos da página atual
    const currentProducts = produtosFiltrados.slice((currentPage - 1) * productsPerPage, currentPage * productsPerPage);

    const handleFiltroCategoriaChange = (event) => {
        setFiltroCategoria(event.target.value);
        setCurrentPage(1); // Resetar para a primeira página quando mudar o filtro de categoria
    };

    const handleFiltroProdutoChange = (event) => {
        setFiltroProduto(event.target.value);
        setCurrentPage(1); // Resetar para a primeira página quando mudar o filtro de produto
    };

    const handlePageChange = (direction) => {
        if (direction === 'next' && currentPage < totalPages) {
            setCurrentPage(prevPage => prevPage + 1);
        } else if (direction === 'prev' && currentPage > 1) {
            setCurrentPage(prevPage => prevPage - 1);
        }
    };

    const handleCheckboxChange = (produtoId) => {
        setProdutosSelecionados((prevState) => {
            const novoArray = [...prevState];
            const produtoSelecionado = produtos.find(p => p.id === produtoId);

            // Verifica se o produto já foi selecionado
            const produtoIndex = novoArray.findIndex(p => p.id === produtoId);
            if (produtoIndex === -1) {
                novoArray.push(produtoSelecionado);  // Adiciona o produto
            } else {
                novoArray.splice(produtoIndex, 1);  // Remove o produto
            }

            return novoArray;
        });
    };

    // Configuração de paginação
    // const [currentPage, setCurrentPage] = useState(1);
    // const productsPerPage = 6;  // Defina o número de produtos por página

    // Lógica para determinar os produtos que devem ser mostrados na página atual
    const indexOfLastProduct = currentPage * productsPerPage;
    const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
    // const currentProducts = produtos.slice(indexOfFirstProduct, indexOfLastProduct);

    // Função para navegar para a próxima página
    const nextPage = () => {
        if (currentPage < Math.ceil(produtos.length / productsPerPage)) {
            setCurrentPage(currentPage + 1);
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    return (
        <div className="p-4 md:p-8 animate-fade-in max-w-7xl mx-auto">
            <div className="flex flex-col mb-8">
                <h1 className="text-3xl text-white font-bold tracking-wide">Jurídico</h1>
                <p className="text-gray-400 mt-2 text-sm">Geração de Termos de Entrega e Contratos.</p>
            </div>

            <div className="flex flex-col gap-8">
                    {/* Top Row: Cards */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                        <div className="glass-panel p-6 flex flex-col h-full">
                            <h2 className="text-xl font-bold text-white mb-4">Termo de Entrega</h2>
                            <div className="h-px bg-white/10 w-full mb-6 flex-shrink-0"></div>

                            <div className="flex-grow flex flex-col justify-center space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-200 mb-1">Cliente</label>
                                    <select
                                        value={clienteSelecionadoTermo?.id || ''}
                                        onChange={(e) => {
                                            const cliente = clientes.find(c => c.id === Number(e.target.value));
                                            setClienteSelecionadoTermo(cliente);
                                        }}
                                        className="glass-input w-full appearance-none bg-background-darker"
                                    >
                                        <option value="" disabled>Selecione um cliente</option>
                                        {clientes.map(cliente => (
                                            <option key={cliente.id} value={cliente.id}>{cliente.nome}</option>
                                        ))}
                                    </select>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-200 mb-1">Data de Entrega</label>
                                    <MiniCalendar selectedDate={dataEntrega} onChange={setDataEntrega} />
                                </div>
                            </div>

                            <div className="mt-auto pt-6 flex-shrink-0">
                                <button
                                    onClick={handleGerarTermoPDF}
                                    className="glass-button bg-blue-600/80 hover:bg-blue-600 text-white w-full py-2 font-medium"
                                >
                                    Gerar Termo
                                </button>
                            </div>
                        </div>

                        <div className="flex flex-col gap-6">
                            <div className="glass-panel p-6">
                                <h2 className="text-xl font-bold text-white mb-4">Contrato</h2>
                                <div className="h-px bg-white/10 w-full mb-6"></div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-200 mb-1">Cliente do Contrato</label>
                                    <select
                                        value={clienteSelecionadoContrato?.id || ''}
                                        onChange={(e) => {
                                            const cliente = clientes.find(c => c.id === Number(e.target.value));
                                            setClienteSelecionadoContrato(cliente);
                                        }}
                                        className="glass-input w-full appearance-none bg-background-darker"
                                    >
                                        <option value="" disabled>Selecione um cliente</option>
                                        {clientes.map(cliente => (
                                            <option key={cliente.id} value={cliente.id}>{cliente.nome}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="glass-panel p-6">
                                <h2 className="text-xl font-bold text-white mb-4">Filtros</h2>
                                <div className="h-px bg-white/10 w-full mb-6"></div>

                                <div className="grid grid-cols-1 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-200 mb-1">Categoria</label>
                                        <select
                                            value={filtroCategoria}
                                            onChange={handleFiltroCategoriaChange}
                                            className="glass-input w-full appearance-none bg-background-darker"
                                        >
                                            <option value="">Todas</option>
                                            {categorias.map((categoria, index) => (
                                                <option key={index} value={categoria}>{categoria}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-200 mb-1">Filtrar Produto</label>
                                        <input
                                            type="text"
                                            value={filtroProduto}
                                            onChange={handleFiltroProdutoChange}
                                            placeholder="Nome..."
                                            className="glass-input w-full"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    {/* Bottom Row: Lista de Produtos para o Contrato */}
                    <div className="glass-panel overflow-hidden mb-6 border border-white/10">
                            <div className="overflow-x-auto">
                                <table className="w-full text-left text-sm text-gray-300">
                                    <thead className="bg-[#1b2336] text-xs font-semibold text-gray-400 border-b border-white/10">
                                        <tr>
                                            <th className="px-4 py-4 w-16 text-center">Sel</th>
                                            <th className="px-4 py-4">Descrição do Produto</th>
                                            <th className="px-4 py-4">Categoria</th>
                                            <th className="px-4 py-4 text-right">Preço Unitário</th>
                                            <th className="px-4 py-4 text-center">Quantidade</th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-white/5 bg-[#151c2c]">
                                        {currentProducts.map(produto => (
                                            <tr key={produto.id} className="hover:bg-white/5 transition-colors group">
                                                <td className="px-4 py-3 text-center">
                                                    <label className="relative flex items-center justify-center cursor-pointer group">
                                                        <input
                                                            type="checkbox"
                                                            checked={produtosSelecionados.some(p => p.id === produto.id)}
                                                            onChange={() => handleCheckboxChange(produto.id)}
                                                            className="peer sr-only"
                                                        />
                                                        <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center rounded border-2 border-gray-500 peer-checked:border-blue-500 peer-checked:bg-blue-500 transition-all peer-checked:shadow-[0_0_10px_rgba(59,130,246,0.6)]">
                                                            <svg className="w-3 h-3 text-white opacity-0 peer-checked:opacity-100 transition-opacity" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                                                            </svg>
                                                        </div>
                                                    </label>
                                                </td>
                                                <td className="px-4 py-3 font-medium text-gray-200">
                                                    {produto.nome}
                                                </td>
                                                <td className="px-4 py-3 text-gray-400 text-xs">
                                                    {produto.categoria}
                                                </td>
                                                <td className="px-4 py-3 text-right text-green-400 font-medium text-sm">
                                                    {formatarParaBRL(produto.valor)}
                                                </td>
                                                <td className="px-4 py-3">
                                                    <div className={`flex items-center justify-center gap-3 transition-all ${!produtosSelecionados.some(p => p.id === produto.id) ? 'opacity-30 cursor-not-allowed' : 'opacity-100'}`}>
                                                        <button
                                                            onClick={() => handleQuantidadeDecrement(produto.id)}
                                                            disabled={!produtosSelecionados.some(p => p.id === produto.id)}
                                                            className="w-6 h-6 flex items-center justify-center rounded bg-white/5 text-gray-400 hover:bg-white/10 hover:text-white transition-colors"
                                                        >
                                                            -
                                                        </button>
                                                        <input
                                                            type="number"
                                                            value={quantidades[produto.id] !== undefined ? quantidades[produto.id] : 0}
                                                            readOnly
                                                            className="w-12 bg-transparent text-center text-gray-200 font-medium focus:outline-none hide-arrows pointer-events-none"
                                                            min="0"
                                                        />
                                                        <button
                                                            onClick={() => handleQuantidadeIncrement(produto.id)}
                                                            disabled={!produtosSelecionados.some(p => p.id === produto.id)}
                                                            className="w-6 h-6 flex items-center justify-center rounded bg-white/5 text-gray-400 hover:bg-white/10 hover:text-white transition-colors"
                                                        >
                                                            +
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                        {currentProducts.length === 0 && (
                                            <tr>
                                                <td colSpan="5" className="px-4 py-8 text-center text-gray-500">Nenhum produto encontrado.</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Table Pagination (Estoque Style) */}
                        <div className="flex justify-center items-center mt-6 space-x-2">
                            {Array.from({ length: totalPages }, (_, index) => (
                                <button
                                    key={index}
                                    onClick={() => setCurrentPage(index + 1)}
                                    className={`w-10 h-10 rounded-full flex items-center justify-center font-medium transition-all ${currentPage === index + 1
                                        ? 'bg-primary text-white shadow-lg border border-primary/50'
                                        : 'bg-white/5 text-gray-400 hover:bg-white/10 border border-white/5 hover:text-white'
                                        }`}
                                >
                                    {index + 1}
                                </button>
                            ))}
                        </div>

                        {/* Botão para Gerar Contrato */}
                        <div className="mt-8 mb-8 flex justify-center">
                            <button
                                onClick={handleGerarContratoPDF}
                                className="glass-button bg-green-600/80 hover:bg-green-600 text-white px-8 py-3 text-lg font-medium flex items-center justify-center w-full md:w-auto"
                            >
                                Gerar Contrato PDF
                            </button>
                        </div>
                </div>

            {/* Modais de Erro Tailwind */}
            {(erroQuantidade || erroClienteSelecionado || erroDataEntrega || erroProduto) && (
                <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex justify-center items-center z-50 p-4">
                    <div className="glass-panel p-6 max-w-sm w-full animate-fade-in">
                        <h2 className="text-xl font-bold text-red-400 mb-4">Atenção</h2>
                        <div className="text-gray-200 mb-6">
                            {erroQuantidade && <p>Por favor, defina a quantidade para todos os produtos selecionados.</p>}
                            {erroClienteSelecionado && <p>Por favor, selecione um cliente.</p>}
                            {erroDataEntrega && <p>Por favor, informe a data de entrega.</p>}
                            {erroProduto && <p>Nenhum produto foi selecionado.</p>}
                        </div>
                        <div className="flex justify-end">
                            <button onClick={handleCloseError} className="glass-button bg-red-500/20 hover:bg-red-500/40 text-red-400">
                                Fechar
                            </button>
                        </div>
                    </div>
                </div>
            )}
            
            <GlobalLoading isActive={loading} />
        </div>
    );
};

export default TelaContratoTermo;
